"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgDesktopMac = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: 0.48, strokeWidth: 2, d: "M26.5 21a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1" }),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M3 7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm16 16h-7v2h3a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h3v-2H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3M24 9a1 1 0 0 1 1-1h4a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3h-6a1 1 0 1 1 0-2h6a1 1 0 0 0 1-1v-6h-5a1 1 0 1 1 0-2h5v-2h-5a1 1 0 1 1 0-2h5v-1a1 1 0 0 0-1-1h-4a1 1 0 0 1-1-1", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", d: "M13.68 14a2.22 2.22 0 0 1 1.06-1.87 2.3 2.3 0 0 0-1.795-.975c-.765-.075-1.5.45-1.88.45s-1-.44-1.62-.43a2.4 2.4 0 0 0-2.035 1.23c-.865 1.5-.22 3.73.625 4.95.41.595.905 1.265 1.55 1.24s.86-.4 1.61-.4.965.4 1.62.39 1.095-.61 1.5-1.205c.293-.425.524-.89.685-1.38a2.17 2.17 0 0 1-1.32-2M12.655 9.795A2.5 2.5 0 0 0 13.24 8a2.5 2.5 0 0 0-2.129 1.672c-.1.304-.138.624-.111.943a2.09 2.09 0 0 0 1.655-.82" })));
exports.default = SvgDesktopMac;
